import { useTranslation } from "react-i18next";

const Banner = () => {

  const [t, i18n] = useTranslation()

  const banner_video = require("../../../assets/home/banner_video.webm");
  const banner_video_en = require("../../../assets/home/banner_video_en.webm");
  return (
    <div className="banner">
      <a href={t("banner.video_url")} target="_blank">
        <video className="banner-img" autoPlay muted loop src={i18n.language === "es" ? banner_video : banner_video_en} /> 
      </a>
    </div>
  );
};

export default Banner;
